'use client';
import React from 'react';

const announcementText = [
  {
    label: 'NEW SERIES',
    text: 'The Interconnected Universe — How everything from atoms to galaxies shares a common origin story.',
    href: '#articles',
  },
  {
    label: 'TRENDING',
    text: 'Over 200 analysts and writers exploring the inception of everything:',
    phone: '+1 (800) 000-0000',
    href: 'tel:+18000000000',
  },
];

export default function AnnouncementBar() {
  return (
    <div className="bg-[#0d1120] border-b border-[#1e2a3a]">
      <div className="max-w-[1280px] mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-2 py-2.5">
        <div className="flex items-center gap-2">
          <span
            className="text-[#e01a2e] text-[10px] font-bold tracking-widest uppercase"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            {announcementText?.[0]?.label}
          </span>
          <span className="text-[#2d3748]">|</span>
          <a
            href={announcementText?.[0]?.href}
            className="text-[#a0aec0] text-[12px] hover:text-white transition-colors duration-200 line-clamp-1"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            {announcementText?.[0]?.text}
          </a>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <span
            className="text-[#a0aec0] text-[12px]"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            {announcementText?.[1]?.text}
          </span>
          <a
            href={announcementText?.[1]?.href}
            className="text-[#e01a2e] text-[12px] font-bold hover:text-white transition-colors duration-200"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            {announcementText?.[1]?.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
